<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">
          {{
            this.parentRoute.menuName +
              "-资产" +
              (query.category == "0" ? "外调" : "调回")
          }}
        </span>
        <span class="masge">
          当前共有{{ total }}条{{
            query.category == "0" ? "外调信息" : "调回信息"
          }}
        </span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">
            {{ query.category == "0" ? "申请外调" : "申请调回" }}
          </el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            批量删除
          </el-button>

          <SelectFilter class="margin-left20" ref="selectFilter" :options="filterOptions" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-tabs v-model="query.category" @tab-click="handleClick" stretch>
        <el-tab-pane v-for="item in AssetTransferOptions" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" :label="query.category == '0' ? '外调单号' : '调回单号'" width="160"></el-table-column>
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createdUserName" label="创建人" align="center" width="100"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="100">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}") }}
            </div>
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}") }}
            </div>
          </template>
        </el-table-column>
        <template v-if="query.category == '0'">
          <el-table-column prop="warehouseName" label="库房" width="120" show-overflow-tooltip>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="inWarehouseName" label="调回库房" width="120" show-overflow-tooltip></el-table-column>
        </template>
        <template v-if="query.category == '0'">
          <el-table-column prop="warehouseManagerName" label="库房管理员" width="100" show-overflow-tooltip></el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="inWarehouseManagerName" label="库房管理员" width="100" show-overflow-tooltip></el-table-column>
        </template>
        <el-table-column prop="contactor" :label="query.category == '0' ? '外调联系人' : '外部联系人'" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="联系电话" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="date" :label="query.category == '0' ? '外调时间' : '调回时间'" width="100">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.date), "{y}-{m}-{d}") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="reason" :label="query.category == '0' ? '外调原因' : '调回原因'" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-if="scope.row.status != 1 && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import { AssetTransferOptions } from "@/enum";
import {
  GetAssetOutTransfers,
  GetAssetInTransfers,
  RemoveAssetOutTransfers,
  RemoveAssetInTransfer,
} from "@/api";


export default {
  mixins: [GetDataMixin],
  components: { SelectFilter },
  /** 定义属性 */
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      AssetTransferOptions: AssetTransferOptions,
      filterOptions: [
        {
          name: "外调单号",
          type: "input",
          code: "assetOutTransferNo",
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "时间周期",
          type: "date",
          code: "date",
        },
      ],
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    refenceQuery () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
    },
    // 获取列表
    getData () {
      if (this.query.category == "0") {
        GetAssetOutTransfers(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      } else {
        GetAssetInTransfers(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      }
    },
    // 查看信息
    handleInfo (row) {
      this.$router.push(
        "/asset-transfer-edit?formMode=0&id=" +
        row.id +
        "&type=" +
        this.query.category
      );
    },
    // 新建
    handleAdd () {
      this.$router.push(
        "/asset-transfer-edit?formMode=1&type=" + this.query.category
      );
    },
    // 编辑
    handleUpdate (row) {
      this.$router.push(
        "/asset-transfer-edit?formMode=2&id=" +
        row.id +
        "&type=" +
        this.query.categor
      );
    },
    // 审批
    handleApprove (row) {
      this.$router.push(
        "/asset-transfer-edit?formMode=3&id=" +
        row.id +
        "&type=" +
        this.query.categor
      );
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          if (this.query.category == "0") {
            return RemoveAssetOutTransfers({ ids });
          } else {
            return RemoveAssetInTransfer({ ids });
          }
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    handleClick (tab) {
      // this.query.type =
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () { },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 200px;
  margin-bottom: 10px;
}
</style>
